module.exports = __webpack_public_path__ + "static/img/pa1.cc25dbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/pa1.png
// module id = MG94
// module chunks = 0